import Model from '@/models/Model';
import Collection from '@/models/Collection';

export class Module extends Model {

	// Default attributes that define the "empty" state.
	defaults() {
		return {
			id: null,
			orderBy: null,
			movable: null,
			parent: null,
			name: '',
			class_name: '',
			type: '',
			sort: '',
			show: null,
			group: '',
			label: '',
			description: '',
			options: [],
			fields: [],
		};
	}

	// Attribute mutations.
	mutations() {
		return {
			id: id => Number(id) || null,
		};
	}

	// Route configuration
	routes() {
		return {
			// create: '/modules',
			fetch: '/modules/{id}',
			// patch: '/modules/{id}',
			// delete: '/modules/{id}',
		};
	}

	options() {
		return {
			patch: true,
		};
	}

	get route() {
		if (this.type === 'single') {
			return { name: 'edit', params: { name: this.name, id: 1 } }
		}
		return { name: 'module', params: { name: this.name } }
	}
}

export class Modules extends Collection {

	model() {
		return Module
	}

	defaults() {
		return {
			// orderBy: 'name',
		};
	}

	routes() {
		return {
			fetch: 'modules',
		};
	}

	get sidebar() {
		const items = this.models.filter((model) => model.type !== 'submodule')
		const reduced = items.reduce((res, obj) => {
			const key = obj.group
			const newObj = {group: key, name: obj.label, to: obj.route }
			if (res[key]) {
				res[key].push(newObj)
			} else {
				res[key] = [ newObj ]
			}
			return res
		}, {})
		return reduced
	}
}

// Single row of ModuleData
export class ModuleDataItem extends Model {
	
	defaults() {
		return {
			id: null,
			moduleName: '',
		}
	}

	routes() {
		return {
			create: 'entries/{moduleName}',
			fetch: 'entries/{moduleName}/{id}',
			patch: 'entries/{moduleName}/{id}',
		};
	}

	options() {
		return {
			patch: true,
		};
	}
}

// All the rows of data for a specific module
export class ModuleData extends Collection {

	defaults() {
		return {
			name: '',
		}
	}
	model() {
		return ModuleDataItem
	}

	routes() {
		return {
			fetch: 'entries/{name}'
		}
	}
}